import { RecruiterIdsActionTypes, RecruiterIdsState, SET_RECRUITER_IDS_SUCCESS } from "store/reducers/types/recruiterId";

const defaultState: RecruiterIdsState = {
  isLoading: false,
  errorMessage: "",
  contents: {
    recruiterIds: []
  }
};

export default function recruiterIds(state = defaultState, action: RecruiterIdsActionTypes): RecruiterIdsState {
  switch (action.type) {
    case SET_RECRUITER_IDS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false
      };
    default:
      return state;
  }
}
